import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { grey } from '@mui/material/colors';
import { useL10n } from '@uplift/hooks';
import { Button } from '@uplift/ui-v2';

export type FixedActionBarProps = {
  onSave: () => void;
  saving?: boolean;
  onSaveForLater: () => void;
  savingForLater?: boolean;
};

export const FixedActionBar: React.VFC<FixedActionBarProps> = ({ onSave, onSaveForLater, saving, savingForLater }) => {
  const l10n = useL10n();
  const { classes } = useStyles();

  return (
    <Box className={classes.container}>
      <Button
        variant="outlined"
        color="secondary"
        size="large"
        onClick={onSaveForLater}
        loading={savingForLater}
        disabled={saving}
      >
        {l10n.clinicalNotes.saveAndFinishLater}
      </Button>
      <Button
        variant="contained"
        color="secondary"
        size="large"
        onClick={onSave}
        loading={saving}
        disabled={savingForLater}
      >
        {l10n.clinicalNotes.submitSessionNotes}
      </Button>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  container: {
    padding: theme.spacing(2),
    background: theme.palette.background.paper,
    boxShadow: `inset 0 1px 0 ${grey[300]}`,
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    zIndex: theme.zIndex.appBar,
    position: 'sticky',
    bottom: 0,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
}));
